/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckJourney } from './PaxCheckJourney';
import {
    PaxCheckJourneyFromJSON,
    PaxCheckJourneyFromJSONTyped,
    PaxCheckJourneyToJSON,
    PaxCheckJourneyToJSONTyped,
} from './PaxCheckJourney';
import type { PaxCheckPaxSession } from './PaxCheckPaxSession';
import {
    PaxCheckPaxSessionFromJSON,
    PaxCheckPaxSessionFromJSONTyped,
    PaxCheckPaxSessionToJSON,
    PaxCheckPaxSessionToJSONTyped,
} from './PaxCheckPaxSession';

/**
 * MultiPax session (ie booking)
 * @export
 * @interface PaxCheckMultipaxSession
 */
export interface PaxCheckMultipaxSession {
    /**
     * MultiPax session id
     * @type {string}
     * @memberof PaxCheckMultipaxSession
     */
    id: string;
    /**
     * 
     * @type {PaxCheckJourney}
     * @memberof PaxCheckMultipaxSession
     */
    journey: PaxCheckJourney;
    /**
     * List of Pax sessions (ie passengers)
     * @type {Array<PaxCheckPaxSession>}
     * @memberof PaxCheckMultipaxSession
     */
    paxs: Array<PaxCheckPaxSession>;
}

/**
 * Check if a given object implements the PaxCheckMultipaxSession interface.
 */
export function instanceOfPaxCheckMultipaxSession(value: object): value is PaxCheckMultipaxSession {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('journey' in value) || value['journey'] === undefined) return false;
    if (!('paxs' in value) || value['paxs'] === undefined) return false;
    return true;
}

export function PaxCheckMultipaxSessionFromJSON(json: any): PaxCheckMultipaxSession {
    return PaxCheckMultipaxSessionFromJSONTyped(json, false);
}

export function PaxCheckMultipaxSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckMultipaxSession {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'journey': PaxCheckJourneyFromJSON(json['journey']),
        'paxs': ((json['paxs'] as Array<any>).map(PaxCheckPaxSessionFromJSON)),
    };
}

export function PaxCheckMultipaxSessionToJSON(json: any): PaxCheckMultipaxSession {
    return PaxCheckMultipaxSessionToJSONTyped(json, false);
}

export function PaxCheckMultipaxSessionToJSONTyped(value?: PaxCheckMultipaxSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'journey': PaxCheckJourneyToJSON(value['journey']),
        'paxs': ((value['paxs'] as Array<any>).map(PaxCheckPaxSessionToJSON)),
    };
}

